import type { Job } from '../api/types';
import { jobStatusInfo, stepLabel } from '../format';
import { JobProgress } from './JobProgress';

export function JobDetails({ job }: { job: Job }) {
  return (
    <>
      <JobProgress job={job} />
      {job.error && <div className="alert danger">{job.error}</div>}
      <a className="btn small" href={`/api/v1/jobs/${encodeURIComponent(job.id)}/log/download`}>
        ジョブのログを保存（.log）
      </a>
      <ol className="steps">
        {job.steps.map((step) => (
          <li key={step.name}>
            <span className="step-icon" aria-hidden>
              {step.status === 'succeeded'
                ? '✓'
                : step.status === 'failed'
                  ? '✕'
                  : step.status === 'running'
                    ? '…'
                    : '·'}
            </span>
            <span>{stepLabel[step.name] ?? step.name}</span>
            <code className="faint">{step.name}</code>
            <span className="faint small">{jobStatusInfo[step.status]?.label}</span>
            {step.error && <div className="alert danger">{step.error}</div>}
          </li>
        ))}
      </ol>
      {job.result?.consoleOutput !== undefined && (
        <div className="stack">
          <strong>コンソールコマンドの出力</strong>
          <pre>{job.result.consoleOutput || '（出力なし）'}</pre>
        </div>
      )}
      {job.result?.gameSettings && (
        <div className="stack">
          <strong>ゲーム設定の反映結果</strong>
          {job.result.gameSettings.map((result) => (
            <p className="small" key={result.dimension + result.key}>
              {result.dimension}: {result.rule} = {String(result.value)} —{' '}
              {result.status === 'applied' ? '反映・確認済み' : '起動後に反映待ち'}
            </p>
          ))}
        </div>
      )}
    </>
  );
}
